import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0860e63e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "ant-skeleton ant-skeleton-active css-eq3tly"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-skeleton-content" }, [
  /*#__PURE__*/_createElementVNode("ul", { class: "ant-skeleton-paragraph" }, [
    /*#__PURE__*/_createElementVNode("li")
  ])
], -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 0,
  class: "ss-informacao-adicional-select ss-tag",
  style: 'background-color: #a0aec1;'
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.aguardarConclusaoCarregamento(_ctx.computedCodigoSelecionado,_ctx.computedCodigosSelecionados))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : (_openBlock(), _createBlock(_component_a_select, {
          key: 1,
          mode: _ctx.props.varios?'multiple':null,
          value: _ctx.props.varios?_ctx.computedCodigosSelecionados:_ctx.computedCodigoSelecionado,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (_ctx.props.varios?_ctx.computedCodigosSelecionados = $event:_ctx.computedCodigoSelecionado = $event)),
          onChange: _ctx.change,
          onFocus: _cache[1] || (_cache[1] = ($event: any) => (_ctx.pesquisarUsuario(''))),
          onSearch: _cache[2] || (_cache[2] = ($event: any) => (_ctx.pesquisarUsuario($event))),
          onBlur: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selecionarBase.emDigitacao = false)),
          "show-search": "",
          optionFilterProp: "label",
          class: _normalizeClass('ss-tamanho-completo ' + _ctx.props.classCss),
          allowClear: _ctx.props.limparSelecao,
          placeholder: _ctx.props.placeholder,
          filterOption: false,
          "not-found-content": _ctx.selecionarBase.buscandoDados ? undefined : null,
          disabled: _ctx.props.disabled,
          title: _ctx.props.title,
          "data-coluna": _ctx.props.dataAttributeColuna
        }, _createSlots({
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selecionarBase.listaItensConsultaRapida, (Usuario) => {
              return (_openBlock(), _createBlock(_component_a_select_option, {
                key: Usuario.codigo,
                value: Usuario.codigo
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(Usuario.textoIdentificacao) + " ", 1),
                  (!_ctx.props.varios && Usuario.informacaoAdicional !== '' && Usuario.informacaoAdicional !== undefined)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(Usuario.informacaoAdicional), 1))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["value"]))
            }), 128))
          ]),
          _: 2
        }, [
          (_ctx.selecionarBase.buscandoDados)
            ? {
                name: "notFoundContent",
                fn: _withCtx(() => [
                  _createTextVNode(" Buscando Usuários "),
                  _createVNode(_component_a_spin)
                ]),
                key: "0"
              }
            : undefined
        ]), 1032, ["mode", "value", "onChange", "class", "allowClear", "placeholder", "not-found-content", "disabled", "title", "data-coluna"]))
  ]))
}